import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'



class VersionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {


            date: [
                { value: 1, label: "Ascending" },
                { value: 2, label: "Descending" }],

        }

        this.modal = this.modal.bind(this);

    }

    modal() {
        //     console.log(this.state.modal);
        //   this.setState({ modal: !this.state.modal });
        //   setTimeout(() => console.log(this.state.modal), 250);

        this.props.toggleVersionModal(false)

    }








    render() {




        return (


            <div>
                <Modal className="" isOpen={this.props.action} >
                    <div className={"modal-bg" + (this.modal === 'false' ? 'open' : '')}>
                        <div >
                            <ModalHeader HeaderStyle="modal-header">
                                <div className="modal-text"><h4 >{this.props.headertitle}</h4></div>

                                <button type="button" className="close" aria-label="Close" onClick={this.modal}   >
                                    <span aria-hidden="true">&times;</span>
                                </button>

                            </ModalHeader>
                        </div>
                        <div>
                            <ModalBody Style="modal-body modalbodys">

                                <div className="row ">
                                    <div className="col-md-4"></div>
                                    <div className="col-8">
                                        <div className="d-inline-flex p-2 ml-2 mt-2">
                                            <div className="my-auto">Version:</div>

                                            <div className="btn-group btn-group-toggle ml-2 " data-toggle="buttons">
                                                <label className="btn btn-secondary active">
                                                    <input type="radio" name="options" id="option1" checked /> Ascending
                            </label>
                                                <label className="btn btn-secondary">
                                                    <input type="radio" name="options" id="option2" /> Descending
                            </label>

                                            </div>
                                        </div>


                                    </div>
                                </div>





                                {this.props.data.map((item) => {
                                    return (

                                        <div className="pt-2 pb-2 ml-2 mr-2">
                                            <div className="row  border-radius-modal ">
                                                <div className="col-8">
                                                    <div><h5>PO768668.pdf</h5></div>
                                                    <div className="text-left">comments(<em>if any</em>):</div>
                                                    <div className=" row text-left">
                                                        <div className="col ">Version:</div>
                                                        <div className="col">Uploaded On:</div>

                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="row pt-4 ">
                                                        <div className="ml-4 border" > <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" /></div>
                                                        <div className="ml-4 border"> <FontAwesomeIcon icon={'check-circle'} color={"green"} size="lg" /></div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    )
                                })}








                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    {/* <Link  to ={{ pathname: this.props.path,state : {} }}> */}
                                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="button">Ok</button>
                                    {/* </Link> */}

                                </div>


                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
            </div>




        )

    }
}


export default VersionModal;